import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MarketingHeader from '../components/marketing/MarketingHeader';
import HeroSection from '../components/marketing/HeroSection';
import StatsSection from '../components/marketing/StatsSection';
import SolutionsSection from '../components/marketing/SolutionsSection';
import FeaturesSection from '../components/marketing/FeaturesSection';
import IntegrationsSection from '../components/marketing/IntegrationsSection';
import SecuritySection from '../components/marketing/SecuritySection';
import TestimonialsSection from '../components/marketing/TestimonialsSection';
import PricingSection from '../components/marketing/PricingSection';
import ResourcesSection from '../components/marketing/ResourcesSection';
import CtaSection from '../components/marketing/CtaSection';
import MarketingFooter from '../components/marketing/MarketingFooter';
import BackToTopButton from '../components/marketing/BackToTopButton';

const LandingPage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Handle anchor links - INSTANT, NO SCROLL ANIMATION
    // Small delay to ensure page is fully rendered when navigating from other pages
    const timer = setTimeout(() => {
      if (location.hash) {
        const elementId = location.hash.substring(1); // Remove the #
        const element = document.getElementById(elementId);
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const targetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: targetPosition,
            behavior: 'instant' as ScrollBehavior
          });
          
          // Add subtle animation to the target element
          element.style.opacity = '0';
          element.style.transform = 'translateY(20px)';
          element.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
          
          requestAnimationFrame(() => {
            element.style.opacity = '1';
            element.style.transform = 'translateY(0)';
          });
          
          setTimeout(() => {
            element.style.transition = '';
          }, 600);
        }
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'instant' as ScrollBehavior
        });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <MarketingHeader />
      <main>
        <HeroSection />
        <StatsSection />
        <SolutionsSection />
        <FeaturesSection />
        <IntegrationsSection />
        <SecuritySection />
        <TestimonialsSection />
        <PricingSection />
        <ResourcesSection />
        <CtaSection />
      </main>
      <MarketingFooter />
      <BackToTopButton />
    </div>
  );
};

export default LandingPage;

